import { USER_MENU } from 'core/constants'
import * as Heroicons from '@heroicons/vue/outline'

type HeroiconKey = keyof typeof Heroicons

function getIconFromApiString(apiIconString: string): any {
  const iconKey = apiIconString as HeroiconKey
  return Heroicons[iconKey] || Heroicons.HomeIcon
}

// Global route aliases to map API route names
const routeAliases: Record<string, string> = {
  Dashboard: 'Devices',
}

const navigation = (sectionKey: string, t: any) => {
  const storedData = localStorage.getItem(USER_MENU)
  if (!storedData) 
    return []

  const data = JSON.parse(storedData)
  const sections = data?.[sectionKey]
  if (!sections) 
    return []

  const menuItems: any[] = []

  sections.forEach((category: any) => {
    menuItems.push({
      children: undefined,
      color: 'text-indigo-410',
      title: t(category.name.toUpperCase()),
      name: category.name.toUpperCase(),
      separator: true,
      href: '/',
      icon: getIconFromApiString(category.schema?.[0]?.icon),
      requiresAuth: true,
      hasChild: false,
    })

    category.schema.forEach((item: any) => {
      if (item.user_permission) {
        const icon = getIconFromApiString(item.icon)
        const name = routeAliases[item.name] || item.name
        const title = item.title ? t(item.title) : t(item.name)
        let children = undefined
        let hasChild = false

        if (item.models && item.models.length > 0) {
          children = []

          item.models.forEach((model: any) => {
            if (model.name === 'ADevices') 
              return

            children.push({
              name: routeAliases[model.name] || model.name,
              title: t(model.title || model.name),
              href: model.url,
              requiresAuth: true,
            })
          })

          hasChild = true
        }

        menuItems.push({
          children,
          color: 'text-indigo-410',
          title,
          name,
          href: item.url,
          separator: false,
          icon,
          requiresAuth: true,
          hasChild,
        })
      }
    })
  })

  return menuItems
}

export default navigation